module.exports = __webpack_public_path__ + "img/icon-appointment.09419e95.png";